import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Error Boundary caught an error", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div
            style={{
              textAlign: "center",
              padding: "28px 16px",
              maxWidth: 440,
              margin: "0 auto",
              borderTop: "3px solid #b42318",
            }}
          >
            <h2
              style={{
                margin: "0 0 10px",
                fontSize: 18,
                fontWeight: 600,
                color: "#111827",
              }}
            >
              Something went wrong
            </h2>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                lineHeight: 1.5,
                color: "#6b7280",
              }}
            >
              {this.state.error?.message ?? "Unknown error"}
            </p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
